import { Component, EventEmitter, OnInit, Output, Input, OnChanges } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ConfigurationService, Configuration } from "../../../core";

@Component({
  standalone: false,
  selector: "app-dispatch-type-code",
  templateUrl: "./dispatch-type-code.component.html",
  styleUrls: ["./dispatch-type-code.component.scss"],
})
export class DispatchTypeCodeComponent implements OnInit, OnChanges{
  @Input() disabledSelect: boolean = false;
  @Input() isMultiple: boolean = true;
  @Input() listByDefault: boolean = false;
  @Input() listToFilter: any[] = [];
  @Input() isNotRequired: boolean = true;
  @Input() filterCapacity: boolean = false;
  @Input() placeholder: string = "Tipo de despacho";
  @Input() hint: string;
  listOfDispatchTypes: any[] = [];
  @Output() changeTypeOfDispatch = new EventEmitter<any>();
  @Output() dispatchTypesListed = new EventEmitter<Configuration[]>();
  dispatchTypeCode = new FormControl();

  constructor(private configurationService: ConfigurationService) {}

  ngOnInit() {}

  ngOnChanges(){
    if(this.listByDefault){
      this.getTypeOfDispatches();
    }
  }

  onGetTypeOfDispatches(){
    if(!this.listByDefault){
      this.getTypeOfDispatches();
    }
  }

  getTypeOfDispatches() {
    if (!this.listOfDispatchTypes.length) {
      this.configurationService
      .read("DISPATCH_TYPE")
      .subscribe((response: Configuration[]) => {
        if (response) {
          this.listOfDispatchTypes = this.filterList(response);
          if (this.filterCapacity) {            
            this.listOfDispatchTypes = this.listOfDispatchTypes.filter((dispatchType) => {
              if (dispatchType.configMetadata && dispatchType.configMetadata.capacity) {
                return dispatchType;
              }
            });

          }
          this.dispatchTypesListed.emit(this.listOfDispatchTypes);
        }
        });
    }
  }

  filterList(listOfDispatchTypes: Configuration[]): Configuration[] {
    const listOfDispatchTypesCopy = [...listOfDispatchTypes];
    if (this.listToFilter && this.listToFilter.length > 0) {
      this.listToFilter.map((item) => {
        const indexFound = this.findDispatchType(listOfDispatchTypesCopy, item);
        if (indexFound > -1) {
          listOfDispatchTypesCopy.splice(indexFound, 1);
        }
      });
    }
    return listOfDispatchTypesCopy;
  }

  findDispatchType(listOfDispatchTypes: Configuration[], item: any): number {
    return listOfDispatchTypes.findIndex(
      (dispatchType) => item.dispatchTypeCode == dispatchType.configValue
    );
  }

  onChangeTypeOfDispatch() {
    this.changeTypeOfDispatch.emit(this.dispatchTypeCode.value);
  }

  cleanForm() {
    this.dispatchTypeCode.setValue(null);
  }

  setDispatchTypeCode(dispatchTypeCode: any) {
    this.dispatchTypeCode.setValue(dispatchTypeCode);
    this.onChangeTypeOfDispatch();
  }
}
